import { InputAdornment, InputBaseComponentProps, InputBaseProps, MenuItem, TextField } from "@mui/material";
import CommonUtil from "@utils/utility";
import Icon from "../../Icon/Icon";
import useStyles from "@hooks/useStyle";
import styles from "./styles";
import { MvTextBoxPropsInterface } from "@mv-components/types";

const TextBox = (props: MvTextBoxPropsInterface) => {
	const {
		label,
		value,
		placeholder,
		prefix,
		suffix,
		disabled,
		options,
		itemKey,
		multiline,
		rows,
		error,
		className,
		extraClass,
		type, // password or text
		onChange,
		inputmode, // numeric or nothing
		onKeyPress = () => {},
		onSuffixClickHandler,
		callCloser,
		inputClassName,
		noBorder,
		touched,
	} = props;

	const { classes, cx } = useStyles(styles) as any;

	const inputProps: InputBaseProps = {};
	const inputElementProps: InputBaseComponentProps = {};
	const _inputLabelProps = {};
	if (prefix) {
		inputProps.startAdornment = (
			<InputAdornment position="start" className={classes.prefix}>
				{prefix}
			</InputAdornment>
		);
	}
	if (suffix) {
		inputProps.endAdornment = (
			<InputAdornment position="end" className={classes.suffix} onClick={onSuffixClickHandler}>
				{suffix}
			</InputAdornment>
		);
	}

	if (inputClassName) {
		inputProps.className = inputClassName;
	}

	if (inputmode) {
		inputElementProps.inputMode = inputmode;
	}

	const helperTextUpdated = CommonUtil.getHelperTxt(props);

	if (noBorder) {
		inputProps.classes = {
			root: classes.noBorderRoot,
			focused: classes.noBorderFocused,
		};
	}

	return (
		<TextField
			label={label}
			className={cx(
				classes.textBox,
				extraClass,
				disabled ? classes.textBoxDisable : null,
				className ? classes[className] : null
			)}
			value={value}
			onChange={(event) => {
				if (callCloser) {
					return onChange(itemKey)(event);
				}
				onChange({ event, itemKey });
			}}
			margin="normal"
			variant="outlined"
			placeholder={placeholder}
			error={error ?? CommonUtil.isError(props)}
			helperText={helperTextUpdated ?? undefined}
			InputProps={inputProps}
			disabled={disabled}
			select={!!options}
			type={type}
			multiline={!!(multiline ?? rows)}
			rows={rows}
			InputLabelProps={_inputLabelProps}
			inputProps={inputElementProps}
			onKeyDown={(event) => {
				onKeyPress(event, props);
			}}
			focused={touched ?? undefined}
		>
			{options
				? options.map((option) => {
						return (
							<MenuItem
								key={option.value || option.label}
								value={option.value !== undefined ? option.value : option.label}
								disabled={option.disabled}
							>
								{option.icon ? <Icon src={option.icon} className={classes.iconClass} /> : null}
								{option.label}
							</MenuItem>
						);
				  })
				: null}
		</TextField>
	);
};

export default TextBox;
